import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import axios from "axios";
import { ToastContainer ,toast } from "react-toastify";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function CheckEmails(){
    const getRole = Cookies.get("user_role");
    const getUsername = Cookies.get("username");
    const navigate = useNavigate();

    const API_URL = BASE_URL+"/getemails";
    
    const [emails, setEmail] = useState([]);

    useEffect(() => {
        axios.get(API_URL, {
            headers: {
                "Authorization": apiKey,
                "Content-Type": "application/json"
            }
        })
        .then(
            res => {
                setEmail(res.data);
                setLoading(false);
            }
        )
        .catch(
            error => {
                console.log("There was an error", error)
            }
        )
    }, [])

    // search table code..
    const searchTable = (e) => {
        const input = document.getElementById("search");
        const filter = input.value.toLowerCase();
        const table = document.getElementById("Table");
        const rows = table.getElementsByTagName("tr");
    
        for (let i = 1; i < rows.length; i++) { // Start at 1 to skip the header row
            const cells = rows[i].getElementsByTagName("td");
            let match = false;
    
            for (let j = 0; j < cells.length; j++) {
                if (cells[j]) {
                    const cellValue = cells[j].textContent || cells[j].innerText;
                    if (cellValue.toLowerCase().indexOf(filter) > -1) {
                        match = true;
                        break;
                    }
                }
            }
    
            rows[i].style.display = match ? "" : "none";
        }
    }

    // select all code
    const selectAll = () => {
        const selAll = document.getElementById('selectAll');
        const rows = document.querySelectorAll('#Table tbody tr');

        rows.forEach(row => {
            if (row.style.display !== 'none') {
                const checkbox = row.querySelector('input[name="ids[]"]');
                if (checkbox) {
                    checkbox.checked = selAll.checked; // Select or deselect based on the "Select All" checkbox
                }
            }
        })
        
    }

    // Bulk Edit / Delete
    const bulkEdit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const status = formData.get("action");
        const ids = formData.getAll("ids[]");

        if (status === "Delete" && ids.length === 0) {
            alert("Please select at least one email to delete.");
            return;
        }

        if (status === "Delete") {
            try {
                await Promise.all(
                    ids.map((id) =>
                        axios.delete(`${BASE_URL}/deleteemail/${id}`, {
                            headers: { Authorization: apiKey },
                        })
                    )
                );
                // alert("Selected leads deleted successfully.");
                toast.success("Selected emails deleted successfully.");
                setTimeout(() => {
                    navigate(0);
                }, 2000);
            } catch (error) {
                console.error("Error deleting emails:", error);
            }
        }
    };
    const [loading, setLoading] = useState(true);
    if (loading) return <Loader />;
    return(
        <div className="container">
            <ToastContainer />
            <form onSubmit={bulkEdit}>
                <h1 className="text-light">Emails</h1>
                <br />
                <div className="row">
                    <div className="col-sm-2">
                        <Link to="/emails/addemail"><button className="btn btn-primary">Add New Email</button></Link>
                    </div>
                    <div className="col-sm-3">
                        <input type="text" class="form-control" id="search" placeholder="Search here..." onKeyUp={searchTable} />
                    </div>
                    <div className="col-sm-3">
                        <select name="action" className="p-1 m-1" style={{ width: "150px" }}>
                            <option value="Active">Active</option>
                            <option value="Deactive">Deactive</option>
                            <option value="Delete">Delete</option>
                        </select>
                        <button className="btn btn-primary">Apply</button>
                    </div>
                </div>
                <br /><br />
                <table className="table table-striped table-dark" id="Table">
                    <thead>
                        <tr>
                            <th scope="col"><input type="checkbox" id="selectAll" onChange={selectAll}/></th>
                            <th scope="col">Host Name</th>
                            <th scope="col">Port</th>
                            <th scope="col">Email</th>
                            <th scope="col">Create At</th>
                            <th scope="col">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {emails.map(email => (
                            <tr>
                                <td>
                                    <input type="checkbox" value={email.Id} name="ids[]" />
                                </td>
                                <td>{email.Host_Name}</td>
                                <td>{email.Port}</td>
                                <td>{email.Email}</td>
                                <td>{email.Created_At}</td>
                                <td>
                                    {getUsername != email.Host_Name &&
                                        <Link to={`/emails/deleteemail/${email.Id}`}><i class="bi bi-trash3 text-danger"></i></Link>
                                    }
                                </td>
                            </tr>
                        ))}
                        {emails.length == 0 &&
                            <tr>
                                <td colSpan="9" className="text-center">No records available to show.</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </form>
        </div>
    )
}